import { IMemberProps } from 'common/interface/props';
import Grid from 'components/UI/atoms/Grid';
import WakeUpLoginForm from 'components/UI/organisms/WakeUpLoginForm';
import Container from 'components/UI/atoms/Container';
import Banner from 'components/UI/molecules/Banner';

export default function WakeUpLogin({ solType }: IMemberProps) {
  return (
    <>
      {/* <Banner imgPath="/images/bg_title3.png" text="상품등록" /> */}

      <Container noBody={true}>
        <WakeUpLoginForm solType={solType} />
      </Container>
    </>
  );
}
